import MainNav from '../../../router/main-nav'
import {AuthService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import Vue from 'vue'

export default {
    name: 'site-header',

    data () {
        return {
            logoSrc: '/static/img/sk-logo.png',
            navItems: MainNav,
            header: null,
            mobileNavActive: false,
            user: null,
            guest: null,
            active: false,
            nouveauLogo: false,
            toggleDialog: false,
            cookieActive: true,
            showUserActivation: false,
            activationLoading: false,
            first_time: true,
            toast: '',
            covidSnack: true,
        }
    },

    methods: {
        resendVerification(){
            this.activationLoading = true;
            AuthService.resendActivation().then(()=> {
                this.$emit('change', true);
                this.showUserActivation = false;
                this.activationLoading = false;
            });
        },
        closeVerificationSnack() {
            this.showUserActivation = false;
            this.activationLoading = false;
        },
        setUser(){
            AuthService.user().then((user)=> {
                if(user != undefined && user != null) {
                    this.user = user;
                    this.guest = user.isGuest();
                    if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                        this.cookieActive = false;
                        this.showUserActivation = true;
                        this.first_time = false;
                    } else {
                        this.showUserActivation = false;
                    }
                }
            })
        },
        checkScroll() {
            if (window.scrollY > this.$el.clientHeight) this.$el.classList.add('sticky');
            if (window.scrollY == 0) this.$el.classList.remove('sticky')
        },
        toggle(el) {
            el.target.nextElementSibling.classList.toggle('hidden-xs')
        },
        setNouveau(to, from) {
            // console.log(to, from)
            // if (to.path === '/type/Nouveau' || (from.path === '/type/Nouveau' && to.name === 'details')) {
            //     this.addNouveau()
            // } else {
            //     this.removeNouveau()
            // }
        },

        addNouveau() {
            this.$root.$el.classList.add('nouveau')
            this.logoSrc = '/static/img/nouveau-logo.png'
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/type/Nouveau'
                }
                if (e.name === 'Cinema Nouveau') {
                    e.name = 'Classic SK'
                    e.path = '/'
                }
            })
        },
        removeNouveau() {
            this.$root.$el.classList.remove('nouveau')
            this.logoSrc = '/static/img/sk-logo.png'
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/'
                }
                if (e.name === 'Classic SK') {
                    e.name = 'Cinema Nouveau'
                    e.path = '/type/Nouveau'
                }
            })
        },
        closeCookie() {
            this.cookieActive = false
            if (!sessionStorage.getItem('cookie')) sessionStorage.setItem('cookie', true)
        },

        closeCovid() {
            this.covidSnack = false
        },

        addNouveauLogo(){
            this.logoSrc = '/static/img/nouveau-logo.png'
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/type/Nouveau'
                }
                if (e.name === 'Cinema Nouveau') {
                    e.name = 'Classic SK'
                    e.path = '/'
                }
            })
        },

        removeNouveauLogo() {
            this.logoSrc = '/static/img/sk-logo.png'
            this.navItems.forEach(function (e) {
                if (e.name === 'Home') {
                    e.path = '/'
                }
                if (e.name === 'Classic SK') {
                    e.name = 'Cinema Nouveau'
                    e.path = '/type/Nouveau'
                }
            })
        },

        toastToggle() {
            this.toast = document.querySelector('.snack')
            if (this.toast) {
                document.querySelector('.main-view').removeAttribute('style')
                let marTop = parseInt(window.getComputedStyle(document.querySelector('.main-view')).getPropertyValue('margin-top'))
                document.querySelector('.main-view').setAttribute('style', 'margin-top:' + (this.toast.offsetHeight + marTop) + 'px')
            } else {
                if (document.querySelector('.main-view')) document.querySelector('.main-view').removeAttribute('style')
            }
        }
    },

    computed: {
        classList() {
            return this.$root.$el.classList.value
        },
        isNouveau() {
            
            if (this.$route.path.includes('/type') && this.$route.path.includes("Nouveau")) {
                Vue.nextTick(() => {
                    this.addNouveau()
                })
                this.nouveauLogo = true
                return {name: 'Cinema Nouveau'}
            } else {
                this.nouveauLogo = false
                return {name: 'Home'}
            }
        },
    },

    created() {
        AuthService.addObserver(this, AuthService.PROFILE_CHANGED, this.setUser); // listen for changes to the user:
        this.setUser(); // get and set the user.

        document.addEventListener('scroll', this.checkScroll, false)
        if (sessionStorage.getItem('cookie')) this.cookieActive = false
        else {
            if (!this.$breakpoints.xs) {
            Vue.nextTick(() => {
                this.toastToggle()
            })
            }
        }
    },

    updated() {
        if (!this.$breakpoints.xs) {
        this.toastToggle()
        }
    },

    destroy() {
        document.removeEventListener('scroll', this.checkScroll)
    },

    watch: {
        '$route' (to, from, el) {
            // console.log(to, from)
            // let path = this.$route.path
            // console.log("includes Nouveau", path, (path.includes('type') && path.includes('Nouveau')))
            // this.setNouveau(to, from)
            if (this.cookieActive) {
                this.closeCookie()
            }
            // if (to.matched[0].name == 'Legal') window.scroll({top: 0, left: 0})
            // else window.scroll({top: 0, left: 0})
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/core/site-header/site-header.js